'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  GIVEN_NAME: 'given',
  FAMILY_NAME: 'family'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.1352/js/constants/NameTypes.js
// module id = 481
// module chunks = 0